/* eslint-disable no-console */
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AdminPageBody } from "../../../layout/AdminPage/AdminPageBody";
import { ProductionList } from "../../molecules";
import { FleetWrapper } from "./Fleet.style";
import { FleetProductionsToolbar } from "./FleetProductionsToolbar";

export const FleetProductions: React.FC = () => {
  const history = useNavigate();
  const { production67969 } = useSelector(
    (state: any) => state.production67969
  );
  const handelEditProduction = (id: string, productionLineId: string) => () => {
    history(`/fleet/production/${id}/production-location/${productionLineId}`);
  };
  return (
    <AdminPageBody pageToolbar={<FleetProductionsToolbar />}>
      <FleetWrapper>
        <ProductionList
          data={production67969}
          showPagination
          showProductionLine
          showDeleteBtn={false}
          editProduction={handelEditProduction}
        />
      </FleetWrapper>
    </AdminPageBody>
  );
};
